module.exports = __webpack_public_path__ + "static/media/event certificate.84261485.svg";